import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Radio } from "@mui/material";

const performanceOptions = [
  { value: "5", label: "Excedió ampliamente las expectativas" },
  { value: "4", label: "Superó las expectativas" },
  { value: "3", label: "Cumplió satisfactoriamente" },
  { value: "2", label: "Cumplió parcialmente" },
  { value: "1", label: "No cumplió" },
];

export default function TasksSection({ tasks, setTasks, tasksErrors, setTasksErrors }) {
  const handleRatingChange = (index, value) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].rating = value;
    setTasks(updatedTasks);

    // ✅ Si la tarea estaba en error y ahora la completaron, sacarla de errors
    if (tasksErrors.includes(index)) {
      const updatedErrors = tasksErrors.filter((i) => i !== index);
      setTasksErrors(updatedErrors);
    }
  };

  return (
    <Box mb={4}>
      <Typography variant="h6" gutterBottom>
        ¿Cumplió satisfactoriamente con sus tareas?
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Tarea</TableCell>
              {performanceOptions.map((option) => (
                <TableCell
                  key={option.value}
                  align="center"
                  sx={{ fontWeight: "bold", fontSize: "0.85rem" }}
                >
                  {option.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tasks.map((task, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: tasksErrors.includes(index) ? "#ffebee" : "inherit",
                }}
              >
                <TableCell sx={{ fontSize: "0.9rem", verticalAlign: "top" }}>
                  <Box>
                    {task.description}
                    {tasksErrors.includes(index) && (
                      <Typography
                        variant="caption"
                        sx={{ color: "error.main", display: "block", mt: 0.5 }}
                      >
                        Falta completar esta evaluación.
                      </Typography>
                    )}
                  </Box>
                </TableCell>
                {performanceOptions.map((option) => (
                  <TableCell key={option.value} align="center">
                    <Radio
                      checked={task.rating === option.value}
                      onChange={() => handleRatingChange(index, option.value)}
                      value={option.value}
                      size="small"
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
